import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
//import certificateImage from '../images/certificates/img.jpeg'; // Placeholder certificate image
import '../styles/certificates.css'; // Custom styles for this sectio
import AwsCertificate from '../components/cert_aws';

 const CertificationSection = () => {
  //const [showModal, setShowModal] = useState(false);
  //const [currentCertificate, setCurrentCertificate] = useState(null);

  // const handleViewCertificate = (certificate) => {
  //   setCurrentCertificate(certificate);
  //   setShowModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  return (
    <>
      {/* Certifications Grid */}
      <section className="certification-section py-5">
        <AwsCertificate/>
      </section>

      {/* Modal to display certificate */}
      {/* <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{currentCertificate ? currentCertificate.title : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {currentCertificate && (
            <img
              src={currentCertificate.image}
              alt={currentCertificate.title}
              className="img-fluid"
              style={{ width: '85%' }} // Ensures the image takes up 75% of the screen width
            />
          )}
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default CertificationSection;

